import 'semantic-ui-less/definitions/modules/checkbox.less';import _default from './Checkbox';
export { _default as default };